import { render, staticRenderFns } from "./BattlePass.vue?vue&type=template&id=35eb0984&scoped=true"
import script from "./BattlePass.vue?vue&type=script&lang=js"
export * from "./BattlePass.vue?vue&type=script&lang=js"
import style0 from "./BattlePass.vue?vue&type=style&index=0&id=35eb0984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb0984",
  null
  
)

export default component.exports